import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { Api } from "../../api/index";
import { FloorWithBuildingInfoResponse } from "../../api/generated/index";
import { FloorMapSaveRejection, PostFloorType, SaveFloorMapType } from "../../types/FloorTypes";

export const getFloors = createAsyncThunk("getFloors", async (): Promise<FloorWithBuildingInfoResponse[]> => {
  return Api.Floor.getAllFloors().then(({ data }) => {
    return data;
  });
});

export const getFloor = createAsyncThunk("getFloor", async (id: number): Promise<FloorWithBuildingInfoResponse> => {
  return Api.Floor.getFloorById(id).then(({ data }) => {
    return data;
  });
});

export const getSvg = createAsyncThunk("getSvg", async (name: number) => {
  return Api.Floor.getSVGById(name).then(({ data }) => {
    return data;
  });
});

export const postFloor = createAsyncThunk(
  "postFloor",
  async (postFloorType: PostFloorType): Promise<FloorWithBuildingInfoResponse> => {
    return Api.Floor.saveFloor(
      0,
      postFloorType.adminName,
      postFloorType.displayName,
      postFloorType.level,
      postFloorType.svg,
      postFloorType.buildingId,
      { headers: { "Content-Type": "multipart/form-data" } },
    ).then(({ data }) => {
      return data;
    });
  },
);

export const deleteFloor = createAsyncThunk(
  "deleteFloor",
  async (id: number): Promise<FloorWithBuildingInfoResponse> => {
    return Api.Floor.deleteFloor(id).then(({ data }) => {
      return data;
    });
  },
);

export const saveFloorMap = createAsyncThunk<
  FloorWithBuildingInfoResponse,
  SaveFloorMapType,
  { rejectValue: FloorMapSaveRejection }
>("saveFloorMap", async (request, { rejectWithValue }) => {
  const workstations = new File([JSON.stringify(request.workstations)], "workstations.json", {
    type: "application/json",
  });
  try {
    const { data } = await Api.Floor.saveFloorMap(
      request.floorId,
      request.floorId,
      request.adminName,
      request.displayName,
      request.level,
      request.svg,
      request.buildingId,
      request.mapRevision,
      workstations,
      { headers: { "Content-Type": "multipart/form-data" } },
    );
    return data;
  } catch (error) {
    const status = axios.isAxiosError(error) ? error.response?.status : undefined;
    if (axios.isAxiosError(error) && (status === 400 || status === 409)) {
      return rejectWithValue({ status, data: error.response?.data });
    }
    throw error;
  }
});
